import { KENO_NUMBER_STATUS, KenoNumber } from '../base/number'
import { CYBER_SNAKES_AUDIO_KEYS } from '../cyber-snakes'
import { KENO_SNAKES_ATLAS_FRAMES, KENO_SNAKES_AUDIO_KEYS, KENO_SNAKES_TEXTURE_KEYS } from './constants'
import { ANIMATION_IDENTIFIERS } from '@Animation/types'

export class KenoSnakesNumber extends KenoNumber {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    number: number,
    isPlayerSelected: boolean,
  ) {
    super(
          scene, 
          x, 
          y, 
          number, 
          isPlayerSelected, 
          ANIMATION_IDENTIFIERS.KENO_SNAKES,
          {
            matchSound: KENO_SNAKES_AUDIO_KEYS.MATCH,
            noMatchSound: CYBER_SNAKES_AUDIO_KEYS.NO_MATCH
          }
        )
  }

  getGlowAtlasFrame() {
    return KENO_SNAKES_ATLAS_FRAMES.NUMBER_GLOW
  }

  getGlowAtlas() {
    return KENO_SNAKES_TEXTURE_KEYS.ATLAS
  }

  createStatusTextureMap(): { [key in KENO_NUMBER_STATUS]: string } {
    return {
      [KENO_NUMBER_STATUS.DEFAULT]: KENO_SNAKES_TEXTURE_KEYS.NUMBER_DEFAULT,
      [KENO_NUMBER_STATUS.SELECTED_PLAYER]: KENO_SNAKES_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED,
      [KENO_NUMBER_STATUS.SELECTED_SYSTEM]: KENO_SNAKES_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED,
      [KENO_NUMBER_STATUS.SELECTED_HIT]: KENO_SNAKES_TEXTURE_KEYS.NUMBER_HIT,
    }
  }
}
